// frontend/src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import SuperAdminDashboard from './pages/superAdmin/Dashboard';
import AdminDashboard from './pages/admin/Dashboard';
import RefereeDashboard from './pages/referee/Dashboard';
import ManageUsers from './pages/superAdmin/ManageUsers';
import ManageSchools from './pages/superAdmin/ManageSchools';
import ManageFiscalYears from './pages/superAdmin/ManageFiscalYears';
import ManageSystemSettings from './pages/superAdmin/ManageSystemSettings';
import ManageQuestionnaires from './pages/superAdmin/ManageQuestionnaires';
import ManageRefereeAssignments from './pages/superAdmin/ManageRefereeAssignments';
import ReportOverview from './pages/superAdmin/ReportOverview';
import SchoolReport from './pages/superAdmin/SchoolReport';
import ManageProfile from './pages/ManageProfile';
import ManageRespondents from './pages/admin/ManageRespondents';
import ManageOIT from './pages/admin/ManageOIT';
import EvaluateOIT from './pages/referee/EvaluateOIT';
import QuestionnairePage from './pages/QuestionnairePage';
import NotFound from './pages/NotFound';
import { checkAuth } from './services/authService';
import ResponseSummary from './pages/superAdmin/ResponseSummary';
import QuestionnaireSuccess from './pages/QuestionnaireSuccess';
import ResetScores from './pages/superAdmin/ResetScores';
import 'animate.css';

// frontend/src/App.js - เพิ่ม import
import DetailedReports from './pages/superAdmin/DetailedReports';


import ScoreSummaryReport from './pages/superAdmin/ScoreSummaryReport';




const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await checkAuth();
        setUser(userData);
      } catch (error) {
        console.error('Authentication error:', error);
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    };

    if (localStorage.getItem('token')) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">กำลังโหลด...</span>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        {/* <Route path="/login" element={user ? <Navigate to="/" /> : <Login setUser={setUser} />} />
        <Route path="/questionnaire/:type/:fiscalYear/:schoolId" element={<QuestionnairePage />} /> */}




  {/* Public routes */}
  <Route path="/login" element={user ? <Navigate to="/" /> : <Login setUser={setUser} />} />
  <Route path="/questionnaire/:type/:fiscalYear/:schoolId" element={<QuestionnairePage />} />
  <Route path="/questionnaire/success" element={<QuestionnaireSuccess />} />


        {/* Protected routes */}
        <Route
          path="/"
          element={
            user ? (
              user.role === 'super_admin' ? (
                <Navigate to="/super-admin/dashboard" />
              ) : user.role === 'admin' ? (
                <Navigate to="/admin/dashboard" />
              ) : (
                <Navigate to="/referee/dashboard" />
              )
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Super Admin routes */}
        <Route
          path="/super-admin/dashboard"
          element={
            user && user.role === 'super_admin' ? (
              <SuperAdminDashboard user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/users"
          element={
            user && user.role === 'super_admin' ? (
              <ManageUsers user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/schools"
          element={
            user && user.role === 'super_admin' ? (
              <ManageSchools user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/fiscal-years"
          element={
            user && user.role === 'super_admin' ? (
              <ManageFiscalYears user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/system-settings"
          element={
            user && user.role === 'super_admin' ? (
              <ManageSystemSettings user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/questionnaires"
          element={
            user && user.role === 'super_admin' ? (
              <ManageQuestionnaires user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route
  path="/super-admin/detailed-reports"
  element={
    user && user.role === 'super_admin' ? (
      <DetailedReports user={user} setUser={setUser} />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/super-admin/score-summary"
  element={
    user && user.role === 'super_admin' ? (
      <ScoreSummaryReport user={user} setUser={setUser} />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

        <Route
          path="/super-admin/referee-assignments"
          element={
            user && user.role === 'super_admin' ? (
              <ManageRefereeAssignments user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/reports"
          element={
            user && user.role === 'super_admin' ? (
              <ReportOverview user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/super-admin/reports/school/:schoolId"
          element={
            user && user.role === 'super_admin' ? (
              <SchoolReport user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* School Admin routes */}
        <Route
          path="/admin/dashboard"
          element={
            user && user.role === 'admin' ? (
              <AdminDashboard user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/admin/respondents"
          element={
            user && user.role === 'admin' ? (
              <ManageRespondents user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/admin/oit"
          element={
            user && user.role === 'admin' ? (
              <ManageOIT user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Referee routes */}
        <Route
          path="/referee/dashboard"
          element={
            user && user.role === 'referee' ? (
              <RefereeDashboard user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/referee/evaluate-oit"
          element={
            user && user.role === 'referee' ? (
              <EvaluateOIT user={user} setUser={setUser} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />


<Route
  path="/super-admin/response-summary"
  element={
    user && user.role === 'super_admin' ? (
      <ResponseSummary user={user} setUser={setUser} />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

<Route
  path="/super-admin/reset-scores"
  element={
    user && user.role === 'super_admin' ? (
      <ResetScores user={user} setUser={setUser} />
    ) : (
      <Navigate to="/login" />
    )
  }
/>

        {/* Common routes */}
        <Route
          path="/profile"
          element={
            user ? <ManageProfile user={user} setUser={setUser} /> : <Navigate to="/login" />
          }
        />

        {/* Not Found */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;